export const PRODUCT_PART_CLASS_NAME = 'ProductPartClassName';
